import { BaseModel } from "@blue-chip/core";
import Area from "./Area";

export default class AreaType extends BaseModel {
  static get belongsTo() {
    return [Area];
  }
}
